import { SVGProps } from 'react'

export const Cmd = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.5C3 4.56701 4.56701 3 6.5 3C8.43299 3 10 4.56701 10 6.5V8.5H14V6.5C14 4.56701 15.567 3 17.5 3C19.433 3 21 4.56701 21 6.5C21 8.43299 19.433 10 17.5 10H15.5V14H17.5C19.433 14 21 15.567 21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5V15.5H10V17.5C10 19.433 8.43299 21 6.5 21C4.56701 21 3 19.433 3 17.5C3 15.567 4.56701 14 6.5 14H8.5V10H6.5C4.56701 10 3 8.43299 3 6.5ZM8.5 8.5V6.5C8.5 5.39543 7.60457 4.5 6.5 4.5C5.39543 4.5 4.5 5.39543 4.5 6.5C4.5 7.60457 5.39543 8.5 6.5 8.5H8.5ZM10 10V14H14V10H10ZM8.5 15.5H6.5C5.39543 15.5 4.5 16.3954 4.5 17.5C4.5 18.6046 5.39543 19.5 6.5 19.5C7.60457 19.5 8.5 18.6046 8.5 17.5V15.5ZM15.5 15.5V17.5C15.5 18.6046 16.3954 19.5 17.5 19.5C18.6046 19.5 19.5 18.6046 19.5 17.5C19.5 16.3954 18.6046 15.5 17.5 15.5H15.5ZM15.5 8.5H17.5C18.6046 8.5 19.5 7.60457 19.5 6.5C19.5 5.39543 18.6046 4.5 17.5 4.5C16.3954 4.5 15.5 5.39543 15.5 6.5V8.5Z"
      fill="currentColor"
    />
  </svg>
)

